import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createRoleAdmin, editRoleAdmin, getRoleInfo,
searchRoleList, getRoleList, getActivePermissions,
deleteRoleAdmin, getPermissionsAdmin } from '../../actions/permissionsAction'
import { Translate } from '../../../language';
import { UseComponentVisible2 } from '../../../containers/UseComponentVisible2'
import { ReactComponent as CloseIcon } from '../../../img/ic_cerrar.svg';
import searchIcon from '../../../img/ic__buscador.png'
import inMemoryJWT from '../../../auth/inMemoryJwt';

const RolesAdmin = ({ history, createRoleAdmin, editRoleAdmin, getPermissionsAdmin, searchRoleList, listPermissionAdmin, getActivePermissions, listRoleAdmin, isLoadinglistPermissionAdmin, getRoleInfo, getRoleList, deleteRoleAdmin, isLoadinglistRoleAdmin }) => {


    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getRoleList()
            getPermissionsAdmin()
        })

    }, [])

    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [nameRole, setNameRole] = useState('')
    const [codeRole, setCodeRole] = useState('')
    const [description, setDescription] = useState('')
    const [permissions, setPermissions] = useState('')
    const [search, setSearch] = useState('')
    const [permissionsID, setPermissionsID] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})
    const [isEnable, setEnable] = useState(false)


    console.log()
    useEffect(() => {
        if (nameRole === '' || description === '' || permissions === '' || codeRole === '') {
            setValidate(false)
        }

        if (nameRole !== '' && description !== '' && permissions !== '' && codeRole !== '') {
            setValidate(true)
        }
    }, [permissions])

    const deletePermissionTag = (id) => {

        setPermissions(prevState => {
            var prevStateDelete = prevState
            delete prevStateDelete[id]
            return ({ ...prevStateDelete })
        })
    }

    useEffect(() => {
        getActivePermissions()
    }, [])
    const {
        ref2,
        isComponentVisible2,
        setIsComponentVisible2
    } = UseComponentVisible2(false);

    const isEmpty = (e) => {
        console.log()
        if (nameRole === '' || description === '' || permissions === '' || codeRole === '') {
            setValidate(false)
        }

        if (nameRole !== '' && description !== '' && permissions !== '' && codeRole !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        console.log()
        if (value.length === 0) {

            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));




        }

    }




    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }




    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nuevo'} rol de administrador`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Nombre de rol:'}
                    </div>
                    <input
                        className='inputs-admin'
                        name="nameRole"
                        value={nameRole}
                        type="text"
                        onChange={e => setNameRole(e.target.value.trimStart())}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                        onMouseOut={e => setNameRole(e.target.value.trim())}
                    />
                    <div className="text-error text-error-admin">{error.nameRole}</div>
                    <div className="text-input-admin">
                        {'Codigo:'}
                    </div>
                    <input
                        className='inputs-admin'
                        name="codeRole"
                        value={codeRole}
                        type="text"
                        autoComplete='off'
                        onChange={e => setCodeRole(e.target.value.trimStart())}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                        onMouseOut={e => setCodeRole(e.target.value.trim())}
                    />
                    <div className="text-error text-error-admin">{error.codeRole}</div>
                    <div className="text-input-admin">
                        {'Descripción:'}
                    </div>
                    <input
                        className='inputs-admin'
                        name="description"
                        value={description}
                        type="text"
                        autoComplete='off'
                        onChange={e => setDescription(e.target.value.trimStart())}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                        onMouseOut={e => setDescription(e.target.value.trim())}
                    />
                    <div className="text-error text-error-admin">{error.description}</div>

                    <div className="search-invite-room">
                        <div ref2={ref2}>
                            <div
                                className="modal-content-button-search-bar"
                                onClick={() =>
                                    setIsComponentVisible2(true)
                                }
                            >
                                <div>
                                    <div className="text-input-admin">
                                        {'Permisos:'}
                                    </div>
                                    <input className="inputs-admin" onChange={(e) => {
                                        console.log()
                                    }} type="text" />
                                </div>
                            </div>
                            {isComponentVisible2 &&
                                <div className='scroll-menu modal-search-bar'>
                                    <div className="modal-results-search-bar">
                                        <div>
                                            {isLoadinglistPermissionAdmin ? <div></div> :
                                                listPermissionAdmin.map((permission) => (
                                                    !permissions[permission._id] &&
                                                    <div
                                                        className="column centerItems"
                                                        key={permission._id}
                                                        onClick={() => {
                                                            setIsComponentVisible2(false)
                                                            setPermissions(prevState => { return { ...prevState, [permission._id]: permission } })
                                                            setPermissionsID(prevState => { return { ...prevState, [permission._id]: permission._id } })
                                                        }} >
                                                        {permission.name}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div>
                            {Object.values(permissions).length > 0 ?
                                Object.values(permissions).map(permission =>
                                    <div className="relative">
                                        <div style={{ width: '80%' }}>
                                            <div className="textBlack" name={permission.name} />{permission.name} </div>
                                        <div onClick={() =>
                                            deletePermissionTag(permission._id)
                                        } className="delete-invite-permissions-icon ml-2">
                                            <CloseIcon className="cls-1" height="18" width="18" />
                                        </div>
                                    </div>
                                )
                                :
                                <div>

                                </div>}
                        </div>
                    </div>

                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setNameRole('')
                                setPermissionsID({})
                                setPermissions({})
                                setDescription('')
                                setCodeRole('')
                                setEnable(false)
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editRoleAdmin({ name: nameRole, description: description, permitsID: Object.keys(permissions), roleId: idEdit, code: codeRole }, history, indexEdit)
                                    setNameRole('')
                                    setPermissionsID({})
                                    setPermissions({})
                                    setCodeRole('')
                                    setDescription('')
                                    setEnable(false)
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { createRoleAdmin({ name: nameRole, description: description, permitsID: Object.keys(permissions), code: codeRole }, history) }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>

                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Roles</div>
                <div className="search-bar-navbar search-bar-admin">
                    <input
                        autoComplete="off"
                        className="input-inside-div"
                        name="categorie"
                        type="text"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value.trimStart())
                            searchRoleList({ search: e.target.value.trimStart() })
                        }}
                    />
                    <img src={searchIcon} alt="img" className="img-search-bar-right" />
                </div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadinglistRoleAdmin ? <div>Cargando...</div> :
                        listRoleAdmin.map((role, index) => (
                            <div key={role._id} className="card-admin">
                                <div className="tittle-card-admin">{role.code}</div>
                                <div className="text-content-card ">{role.name}</div>
                                <div className="text-content-card ">{role.description}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setNameRole(role.name)
                                        setDescription(role.description)
                                        setCodeRole(role.code)
                                        setPermissions({})
                                        role.permitsID.map((permission, index) => (setPermissions(prevState => { return { ...prevState, [permission._id]: permission } })))
                                        setIdEdit(role._id)
                                        setEnable(role.isEnable)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btn-red btns-admin ml-1" onClick={() => { deleteRoleAdmin(role._id, index) }}>Eliminar</div>

                                </div>
                            </div>
                        ))
                    }
                </div>


            </div>



        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadinglistPermissionAdmin: state.permissionsAdmin.isLoadinglistPermissionAdmin,
        listPermissionAdmin: state.permissionsAdmin.listPermissionAdmin,
        isLoadinglistRoleAdmin: state.permissionsAdmin.isLoadinglistRoleAdmin,
        listRoleAdmin: state.permissionsAdmin.listRoleAdmin,
    }
}


export default connect(mapStateToProps, { createRoleAdmin, searchRoleList, editRoleAdmin, getPermissionsAdmin, getRoleInfo, getRoleList, getActivePermissions, deleteRoleAdmin })(RolesAdmin)